import { ChainConfig } from '../types/types';

export const MAX_UINT =
  '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';
export const ZERO_HASH =
  '0x0000000000000000000000000000000000000000000000000000000000000000';
export const ZERO_ADDRESS: `0x${string}` =
  '0x0000000000000000000000000000000000000000';
export const ZERO_FUNC_SIGNATURE = '0x00000000';
export const ANY_ADDRESS = '0xaAaAaAaaAaAaAaaAaAAAAAAAAaaaAaAaAaaAaaAa';
export const ANY_FUNC_SIGNATURE = '0x00000000';
export const ERC20_TRANSFER_SIGNATURE = '0xa9059cbb';
export const SET_PERMISSION_SIGNATURE = '0x6cfe0489';
export const MINT_REP_SIGNATURE = '0x40c10f19';
export const ENS_UPDATE_CONTENT_SIGNATURE = '0x304e6ade';
export const SET_GUILD_CONFIG_SIGNATURE = '0x123f6d67';

export const ERC20_APPROVE_SIGNATURE = '0x095ea7b3';
export const DEFAULT_TOKEN_DECIMALS = 18;
export const NULL_SIGNATURE = '0x00000000';

export const MAX_BLOCKS_PER_EVENTS_FETCH: number = 1000000;

export const CACHE_METADATA_ENS = 'cache.dxvote.eth';

const defaultAlchemyKey = 'FvNKXPCxtzFYrtP4r45pmtxOR0AMCtQv';

export const MAINNET_ID = 1;
export const GNOSIS_ID = 100;
export const LOCALHOST_ID = 1337;
export const GOERLI_ID = 5;
export const ARBITRUM_ID = 42161;
export const ARBITRUM_TESTNET_ID = 421611;

export const DEFAULT_CHAIN_ID =
  process.env.NODE_ENV === 'development' ? LOCALHOST_ID : MAINNET_ID;

export enum CHAIN_ID {
  MAINNET = MAINNET_ID,
  GOERLI = GOERLI_ID,
  ARBITRUM = ARBITRUM_ID,
  ARBITRUM_TESTNET = ARBITRUM_TESTNET_ID,
  LOCALHOST = LOCALHOST_ID,
  GNOSIS = GNOSIS_ID,
}

export const POKT_NETWORK_URLS = {
  '1': 'https://eth-archival.gateway.pokt.network/v1/lb/dda01e253305bbeac6507a80',
  '5': 'https://eth-goerli.gateway.pokt.network/v1/lb/dda01e253305bbeac6507a80',
  '100':
    'https://poa-xdai-archival.gateway.pokt.network/v1/lb/dda01e253305bbeac6507a80',
};

export const NETWORKS: ChainConfig[] =
  process.env.NODE_ENV === 'development'
    ? [
        {
          id: 1,
          name: 'mainnet',
          displayName: 'Ethereum Mainnet',
          defaultRpc: POKT_NETWORK_URLS[1],
          nativeAsset: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
          },
          blockExplorer: 'https://etherscan.io',
          api: 'https://api.etherscan.io',
        },
        {
          id: 5,
          name: 'goerli',
          displayName: 'Goerli Testnet',
          defaultRpc: POKT_NETWORK_URLS['5'],
          nativeAsset: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
          },
          blockExplorer: 'https://goerli.etherscan.io/',
          api: 'https://api-goerli.etherscan.io/',
        },
        {
          id: 100,
          name: 'xdai',
          displayName: 'Gnosis Chain',
          defaultRpc: POKT_NETWORK_URLS['100'],
          nativeAsset: {
            name: 'xDai',
            symbol: 'xDAI',
            decimals: 18,
          },
          blockExplorer: 'https://gnosisscan.io/',
          api: 'https://api.gnosisscan.io/api/',
        },
        {
          id: 42161,
          name: 'arbitrum',
          displayName: 'Arbitrum One',
          defaultRpc: `https://arb-mainnet.g.alchemy.com/v2/${defaultAlchemyKey}`,
          nativeAsset: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
          },
          blockExplorer: 'https://arbiscan.io/',
          api: 'https://api.arbiscan.io/',
        },
        {
          id: 421611,
          name: 'arbitrumTestnet',
          displayName: 'Arbitrum Testnet',
          defaultRpc: `https://arb-rinkeby.g.alchemy.com/v2/${defaultAlchemyKey}`,
          nativeAsset: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
          },
          blockExplorer: 'https://rinkeby-explorer.arbitrum.io/',
        },
        {
          id: 1337,
          name: 'localhost',
          displayName: 'Localhost',
          defaultRpc: `http://127.0.0.1:8545`,
          nativeAsset: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
          },
        },
      ]
    : [
        {
          id: 1,
          name: 'mainnet',
          displayName: 'Ethereum Mainnet',
          defaultRpc: POKT_NETWORK_URLS[1],
          nativeAsset: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
          },
          blockExplorer: 'https://etherscan.io',
          api: 'https://api.etherscan.io',
        },
        {
          id: 5,
          name: 'goerli',
          displayName: 'Goerli Testnet',
          defaultRpc: POKT_NETWORK_URLS['5'],
          nativeAsset: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
          },
          blockExplorer: 'https://goerli.etherscan.io/',
          api: 'https://api-goerli.etherscan.io/',
        },
        {
          id: 100,
          name: 'xdai',
          displayName: 'Gnosis Chain',
          defaultRpc: POKT_NETWORK_URLS['100'],
          nativeAsset: {
            name: 'xDai',
            symbol: 'xDAI',
            decimals: 18,
          },
          blockExplorer: 'https://blockscout.com/xdai/mainnet/',
          api: 'https://blockscout.com/xdai/mainnet/api',
        },
        {
          id: 42161,
          name: 'arbitrum',
          displayName: 'Arbitrum One',
          defaultRpc: `https://arb-mainnet.g.alchemy.com/v2/${defaultAlchemyKey}`,
          nativeAsset: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
          },
          blockExplorer: 'https://arbiscan.io/',
          api: 'https://api.arbiscan.io/',
        },
        {
          id: 421611,
          name: 'arbitrumTestnet',
          displayName: 'Arbitrum Testnet',
          defaultRpc: `https://arb-rinkeby.g.alchemy.com/v2/${defaultAlchemyKey}`,
          nativeAsset: {
            name: 'Ethereum',
            symbol: 'ETH',
            decimals: 18,
          },
          blockExplorer: 'https://rinkeby-explorer.arbitrum.io/',
        },
      ];

export const NETWORK_NAMES: Record<ChainConfig['id'], ChainConfig['name']> =
  NETWORKS.reduce((acc, network) => {
    acc[network.id] = network.name;
    return acc;
  }, {});

export const getNetworkByName = function (networkName: string): ChainConfig {
  return NETWORKS.find(network => network.name === networkName);
};

export const getNetworkById = function (networkId: number): ChainConfig {
  return NETWORKS.find(network => network.id === networkId);
};

export const NETWORK_DISPLAY_NAMES: Record<
  ChainConfig['id'],
  ChainConfig['displayName']
> = NETWORKS.reduce((acc, network) => {
  acc[network.id] = network.displayName;
  return acc;
}, {});

export const DEFAULT_RPC_URLS: Record<
  ChainConfig['id'],
  ChainConfig['defaultRpc']
> = NETWORKS.reduce((acc, network) => {
  acc[network.id] = network.defaultRpc;
  return acc;
}, {});

export const NETWORK_EXPLORERS: { [name: string]: string } = NETWORKS.reduce(
  (acc, network) => {
    if (network?.blockExplorer) {
      acc[network.name] = network.blockExplorer;
    }
    return acc;
  },
  {}
);

export const NETWORK_ASSET_SYMBOL: Record<
  ChainConfig['name'],
  ChainConfig['nativeAsset']['symbol']
> = NETWORKS.reduce((acc, network) => {
  acc[network.name] = network.nativeAsset.symbol;
  return acc;
}, {});

export const INFURA_NETWORK_NAMES = {
  '1': 'mainnet',
  '5': 'goerli',
  '42161': 'arbitrum-mainnet',
  '421611': 'arbitrum-rinkeby',
};

export const ALCHEMY_NETWORK_URLS = {
  '1': 'eth-mainnet.alchemyapi.io',
  '5': 'eth-goerli.alchemyapi.io',
  '42161': 'arb-mainnet.g.alchemy.com',
  '421611': 'arb-rinkeby.g.alchemy.com',
};

export const NETWORK_APIS: { [name: string]: string } = NETWORKS.reduce(
  (acc, network) => {
    if (network?.blockExplorer) {
      acc[network.name] = network.api;
    }
    return acc;
  },
  {}
);
